import "../layout.css";
import React, { useMemo } from "react";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExploreIcon from "@mui/icons-material/Explore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import FitbitRoundedIcon from "@mui/icons-material/FitbitRounded";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import FolderIcon from "@mui/icons-material/Folder";
import WindowOutlinedIcon from "@mui/icons-material/WindowOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useTheme } from "@mui/material";

const sideMenuIcon = [
  {
    name: "Inventory",
    icon: <WarehouseIcon className="me-2" fontSize="medium" />,
  },
  {
    name: "WMS",
    icon: <ExploreIcon className="me-2" fontSize="medium" />,
  },
  {
    name: "Sales",
    icon: <FitbitRoundedIcon className="me-2" fontSize="medium" />,
  },
  {
    name: "Purchase",
    icon: <WindowOutlinedIcon className="me-2" fontSize="medium" />,
  },
  {
    name: "HR",
    icon: <AccountBalanceIcon className="me-2" fontSize="medium" />,
  },
  {
    name: "Finance Management",
    icon: <AttachMoneyIcon className="me-2" />,
  },
  {
    name: "MIS",
    icon: <ManageAccountsIcon className="me-2" />,
  },
  {
    name: "Administrator",
    icon: <AdminPanelSettingsIcon className="me-2" />,
  },
];

function getIconByName(name) {
  const menu = sideMenuIcon.find((item) => item.name === name);
  return menu ? (
    menu.icon
  ) : (
    <FolderIcon
      className="me-2"
      fontSize="medium"
      style={{ color: "#e7c200" }}
    />
  );
}

function getSubIconByName(name) {
  const menu = sideMenuIcon.find((item) => item.name === name);
  return menu ? menu.icon : <ArrowRightIcon fontSize="large" />;
}

export const MenuAccordion = ({
  menus,
  sDrawer = false,
  setDrawer = false,
  sActiveNav = "",
  setActiveNav,
}) => {
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState([]);
  const handleAccordionClick = (accordionName) => {
    if (openMenus.includes(accordionName)) {
      setOpenMenus(openMenus.filter((menu) => menu !== accordionName));
    } else {
      setOpenMenus([accordionName]);
    }
    if (
      accordionName?.toUpperCase() === "WMS" ||
      accordionName?.toUpperCase() === "INVENTORY" ||
      accordionName?.toUpperCase() === "SALES" ||
      accordionName?.toUpperCase() === "PURCHASE" ||
      accordionName?.toUpperCase() === "FINANCE MANAGEMENT"
    ) {
      setActiveNav(accordionName);
    }
  };

  const handleLinkClick = (name, webRoute) => {
    if (name === "General") {
      navigate("/StockSetupDaysTemplate");
    } else {
      navigate(webRoute);
    }
  };

  const renderMenu = (menu) => {
    const isMenuOpen = openMenus.includes(menu.Name1);
    const hasSubMenu = menu.options && menu.options.length > 0;

    if (!hasSubMenu) {
      return (
        <Typography
          key={menu.Cd}
          onClick={() => handleLinkClick(menu.Name1, menu.WebRoute)}
          className="Typography-Sidemenu txt-overflow-ellipse"
          // sx={{ alignItems: "center", borderLeft: "2px solid " }}
        >
          {getSubIconByName(menu.Name1)}

          {menu.Name1}
        </Typography>
      );
    }
    let GCAccordionSummary = sDrawer ? "GC-AccordionSummary" : "";
    return (
      <React.Fragment key={menu.Cd}>
        <Accordion
          expanded={sDrawer ? isMenuOpen : false}
          className="MenuAccordion"
          style={{ boxShadow: "none !important", border: "none !important" }}
        >
          <AccordionSummary
            onClick={() => {
              handleAccordionClick(menu.Name1);
              setDrawer(true);
            }}
            className={
              menu.Name1 === sActiveNav
                ? "nav-activeSideMenu " + GCAccordionSummary
                : "nav-in-activeSideMenu " + GCAccordionSummary
            }
          >
            {sDrawer ? (
              <span className="d-flex align-items-center">
                {/* {getIconByName(menu?.Name1)} */}
                {menu.Name1 === sActiveNav && isMenuOpen ? (
                  <ExpandMoreIcon className="me-2" fontSize="large" />
                ) : (
                  getIconByName(menu?.Name1)
                )}
                <Typography>{menu?.Name1}</Typography>
              </span>
            ) : (
              <>
                {getIconByName(menu?.Name1)}
                {/* <FolderOpenIcon className="me-2" /> */}
              </>
            )}
          </AccordionSummary>
          <AccordionDetails className="GC-AccordionDetails">
            <MenuAccordion
              menus={menu.options}
              sDrawer={sDrawer}
              setDrawer={setDrawer}
              sActiveNav={sActiveNav}
              setActiveNav={setActiveNav}
            />
          </AccordionDetails>
        </Accordion>
      </React.Fragment>
    );
  };

  return <>{menus?.map(renderMenu)}</>;
};

export const RichObjectTreeView = ({ menus = [], setDrawer = () => {} }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isLeaf = (n) => !Array.isArray(n?.options) || n.options.length === 0;

  const handleGo = (route) => {
    if (!route) return;
    navigate(route);
    setDrawer(false);
  };

  const renderNode = (node) => {
    const leaf = isLeaf(node);

    if (leaf) {
      return (
        <div
          key={node?.Cd}
          className="tree-leaf"
          role="button"
          tabIndex={0}
          onClick={() => handleGo(node?.WebRoute)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleGo(node?.WebRoute);
            }
          }}
          aria-label={node?.Name1}
        >
          <span className="tree-label">{node?.Name1}</span>
        </div>
      );
    }

    // parent node
    const defaultOpen = node?.Cd === "root"; // mimic your defaultExpanded=["root"]
    return (
      <details key={node?.Cd} className="tree-branch" open={defaultOpen}>
        <summary className="tree-summary">
          <span className="tree-chevron" aria-hidden="true" />
          <span className="tree-label">{node?.Name1}</span>
        </summary>

        <div className="tree-children">
          {node?.options?.map((child) => renderNode(child))}
        </div>
      </details>
    );
  };

  // stable render of top-level menus
  const content = useMemo(
    () =>
      menus?.map((obj) => (
        <div key={`tree_${obj?.Cd || obj?.Name1}`}>{renderNode(obj)}</div>
      )),
    [menus]
  );

  return (
    <div className="tree-root" style={{ color: theme.palette.primary.main }}>
      {content}
    </div>
  );
};
